import { useState } from 'react';
import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { useStyles, withStyles } from 'legacyStyles';

import { Typography } from 'Components/Typography';

import { countriesCode } from 'constants/countries';

import consultationCountriesProps from 'PropTypes/countries';

const Text = styled.span`
  color: ${theme.colors.neutral[800]};
`;

const styles = {
  root: {},
  foldButton: {
    padding: 0,
    border: 'none',
    font: 'inherit',
    color: 'inherit',
    backgroundColor: 'transparent',
    textAlign: 'left',
    cursor: 'pointer',
    textDecoration: 'underline',

    '&:disabled': {
      cursor: 'not-allowed',
    },
  },
};

const ExtendableTextBlock = ({
  classes,
  dataFrom,
  renderLess,
  renderMore,
  disabled,
  defaultIsOpened,
  className,
  isSupplements,
  consultationProfileCountry,
}) => {
  const [isOpened, setOpen] = useState(defaultIsOpened);
  const { cx } = useStyles();
  return isOpened ? (
    <>
      {renderMore()}
      {isSupplements && (
        <>
          <span>Disclaimer — </span>

          <Text>
            If you are pregnant, breastfeeding, or have a medical condition, please check with your
            medical care team before purchasing or starting supplements.
            <br />
            <br />
            {consultationProfileCountry === countriesCode.CA &&
              'Root Source is a Natural Health Product that can be ordered in Canada for personal use only, not for resale (maximum three months of supply per order).'}
          </Text>
        </>
      )}
      <br />
      <br />
      <button
        className={cx(classes.foldButton, className)}
        onClick={() => setOpen(false)}
        type="button"
      >
        <Typography className={classes.collapseContent} variant="p3">
          Read less
        </Typography>
      </button>
      .
    </>
  ) : (
    <>
      {renderLess()}
      &nbsp;
      <button
        className={cx(classes.foldButton, className)}
        data-click="read-more"
        data-from={`${dataFrom}-card`}
        disabled={disabled}
        onClick={() => setOpen(true)}
        type="button"
      >
        <Typography className={classes.collapseContent} variant="p3">
          Read more
        </Typography>
      </button>
      .
    </>
  );
};

ExtendableTextBlock.defaultProps = {
  disabled: false,
  defaultIsOpened: false,
  isSupplements: false,
  consultationProfileCountry: null,
};

ExtendableTextBlock.propTypes = forbidExtraProps({
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  dataFrom: PropTypes.string,
  renderLess: PropTypes.func.isRequired,
  renderMore: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  defaultIsOpened: PropTypes.bool,
  className: PropTypes.string,
  isSupplements: PropTypes.bool,
  consultationProfileCountry: consultationCountriesProps,
});

ExtendableTextBlock.defaultProps = {
  dataFrom: 'product-cart-card',
  className: null,
};

export default withStyles(ExtendableTextBlock, styles);
